// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2nn8d","productName":"Table_productName__3RprY"};